import React from "react";
import logo from "../../../assets/icons/seven-tri-bg.png";

function Logo({ isSidebar }) {
    return (
        <div className={`flex ${isSidebar ? 'flex-col' : 'flex'}  justify-center items-center`}>
            <div className={`relative ${isSidebar ? 'mb-4' : 'mr-2'}`}>
                {/* Logo Background Enhancement */}
                <div className={`absolute inset-0 bg-gradient-to-br from-[#228B22]/20 to-emerald-500/20 rounded-full blur-lg ${isSidebar ? 'scale-110' : 'scale-100'}`}></div>

                <img
                    src={logo}
                    alt="777 logo"
                    className={`relative z-10 rounded-xl ${isSidebar ? 'h-[10vh] duration-300' : 'w-[80px] duration-300'} drop-shadow-lg`}
                />

                {/* Glow Effect */}
                <div className={`absolute inset-0 bg-[#FFD700]/30 rounded-full blur-md opacity-50 ${isSidebar ? 'scale-75' : 'scale-90'} animate-pulse`}></div>
            </div>

            <div className={`${isSidebar ? 'text-center' : 'flex flex-col'}`}>
                <div
                    className={`${isSidebar ? 'hidden' : 'text-[#228B22] text-[0.9rem]'
                        } font-bold font-mmYein`}
                >
                    777 Sports
                </div>
                {!isSidebar && (
                    <div className="flex items-center mt-1">
                        <div className="w-1 h-1 bg-[#FFD700] rounded-full animate-pulse mr-1"></div>
                        <span className="text-[0.6rem] text-gray-600 font-semibold">Football Betting</span>
                    </div>
                )}
                {isSidebar && (
                    <div className="">
                        <div className="text-slate-100 font-bold text-lg">777 Sports</div>
                        <div className="flex items-center justify-center mt-1">
                            <div className="w-2 h-2 bg-[#FFD700] rounded-full animate-pulse mr-2"></div>
                            <span className="text-xs text-slate-100 font-semibold">Professional Football Betting</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Logo;
